import { render, staticRenderFns } from "./ContractHistoryItem.vue?vue&type=template&id=47c2f078&scoped=true&"
import script from "./ContractHistoryItem.vue?vue&type=script&lang=js&"
export * from "./ContractHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./ContractHistoryItem.vue?vue&type=style&index=0&id=47c2f078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2f078",
  null
  
)

export default component.exports